import React, { useState } from "react";
import {Link, useParams} from "react-router-dom";
import regentHome from "../assets/projects/codezone/regent/home.png";
import regentSearch from "../assets/projects/codezone/regent/search.png";
import regentStorybook from "../assets/projects/codezone/regent/storybook.png";
import kcdHome from "../assets/projects/codezone/kcd/home.png";
import kcdAbout from "../assets/projects/codezone/kcd/about.png";
import kcdStorybook from "../assets/projects/codezone/kcd/storybook.png";
import suiteNYHome from "../assets/projects/codezone/suite-ny/home.jpeg";
import suiteNYProducts from "../assets/projects/codezone/suite-ny/products.jpeg";
import suiteNYBrands from "../assets/projects/codezone/suite-ny/brands.jpeg";
import homepageImg from "../assets/projects/alliance/images/annual-report/an-report-home.png";
import arHome from "../assets/projects/alliance/images/annual-report/an-report-home.png";
import arAdmin from "../assets/projects/alliance/images/annual-report/an-report-admin.png";
import arReportList from "../assets/projects/alliance/images/annual-report/an-report-list.png";
import atmnHome from "../assets/projects/alliance/images/atmn/atmn-home.png";
import atmnLogin from "../assets/projects/alliance/images/atmn/atmn-login.png";
import atmnAdmin from "../assets/projects/alliance/images/atmn/atmn-admin.png";
import allianceHome from "../assets/projects/alliance/images/cmalliance/alliance-home.png";
import allianceLogin from "../assets/projects/alliance/images/cmalliance/alliance-login.png";
import allianceServe from "../assets/projects/alliance/images/cmalliance/alliance-serve.png";
import lifeDashboard from "../assets/projects/codezone/lifebook/dashboard.png";
import lifeLogin from "../assets/projects/codezone/lifebook/login.png";
import lifePage from "../assets/projects/codezone/lifebook/childpage.png";
import ewDashboard from "../assets/projects/codezone/ew-payment/dashboard.png";
import ewLogin from "../assets/projects/codezone/ew-payment/login.png";
import ewPage from "../assets/projects/codezone/ew-payment/page.png";
import ImageModal from "../components/ImageModal";

const ProjectDetail = () => {
    const { id } = useParams(); // Get project ID from URL
    const [modalConfig, setModalConfig] = useState({ isOpen: false, images: [], initialIndex: 0 });

    const projects = [
        {
            id : 8,
            title: "Regent Bank",
            type: "Multisite Digital Platform",
            location: "CodeZone, Tulsa",
            description:
                "Regent Site Build is a multisite digital platform built with Next.js 16 and Sanity CMS 5 within a Turborepo monorepo to centralize content management and power the customer-facing Regent Bank Website.",
            images: [regentHome, regentSearch, regentStorybook],
        },
        {
            id : 7,
            title: "KCD Kitchen Cabinets",
            type: "Headless Web Platform",
            location: "CodeZone, Tulsa",
            description:
                "This project covers the design and development of a new, modern website for Kitchen Cabinet Distributors (KCD). The goal is to deliver a visually elevated, performance-driven digital experience that clearly serves two primary audiences: homeowners seeking inspiration and dealers/trade partners seeking clarity, resources, and confidence. The site is being rebuilt on a modern headless stack to better support KCD’s product-first brand, image-heavy storytelling, and long-term scalability. The experience prioritizes clarity, quality, and ease of navigation — reinforcing KCD’s reputation for dependable service, consistent quality, and strong dealer partnerships.",
            images: [kcdHome, kcdAbout, kcdStorybook],
        },
        {
            description:
                "Built two e-commerce platforms for interior designers using Laravel and Filament. Developed a unified admin dashboard for product management and enhanced user workflows with project list-to-estimate functionality.",
            id: 6,
            location: "CodeZone, United States",
            title: "SuiteNY & The Ancillary Project",
            type: "E-Commerce Platform",
            images: [suiteNYHome, suiteNYProducts, suiteNYBrands],
        },
        {
            id : 5,
            title: "LifeBook - Fostering Connections",
            type: "Web Application",
            location: "CodeZone, United States",
            description:
                "Designed and implemented secure RESTful APIs for managing health records. Developed key features for user account operations and confidential record-sharing, enhancing administrative productivity with Filament.",
            images: [lifeDashboard, lifeLogin, lifePage],
        },
        {
            id : 4,
            title: "East-West Payment Portal",
            type: "Financial Web Platform",
            location: "CodeZone, United States",
            description:
                "Developed a portal to streamline offline donation processing, including batch creation, automated data posting to Classy and Salesforce, and PDF receipt generation for tax purposes.",
            images: [ewDashboard, ewLogin, ewPage],
        },
        {
            id : 3,
            title: "Annual Report - Alliance Churches",
            type: "Report Management System CMAlliance",
            location: "C’S|3 Consultancy Group, United States",
            description:
                "Facilitated efficient and accurate annual report submissions for affiliated churches, improving system robustness and user experience.",
            images: [arHome, arAdmin, arReportList],
        },
        {
            id : 2,
            title: "ATMN - Alliance Transitional Ministry Network",
            type: "Church Support Platform CMAlliance",
            location: "C’S|3 Consultancy Group, United States",
            description:
                "Developed a web application for supporting churches during leadership transitions, ensuring smooth onboarding processes and resource management.",
            images: [atmnHome, atmnLogin, atmnAdmin],
        },
        {
            id : 1,
            title: "Alliance Breakthrough",
            type: "CMS Platform CMAlliance",
            location: "C’S|3 Consultancy Group, United States",
            description:
                "CMAlliance is an integrated online portal for training and ministry development. From preparing to maintain all the workers, pastors, donors, leaders, international workers, and national office employees in a local church. It serves the Alliance family by bringing cost-effective, just-in-time training to Alliance workers, churches, and leaders.",
            images: [allianceHome, allianceLogin, allianceServe],
        }
    ];

    // Find the project with the matching ID
    const project = projects.find((proj) => proj.id === parseInt(id));

    if (!project) {
        return <p>Project not found</p>;
    }

    return (
        <div className="my-48">
            <div className="mt-16">
                <main className="py-6 px-4 sm:p-6 md:py-10 md:px-8">
                    <div className="max-w-4xl mx-auto grid lg:max-w-5xl lg:gap-x-20">
                        {/* Breadcrumb */}
                        <nav className="breadcrumb mb-10">
                            <ul className="flex space-x-2 text-sm text-gray-500">
                                <li >
                                    <Link to="/projects" className="hover:underline text-red-600">
                                        Work
                                    </Link>
                                    <span> / </span>
                                </li>
                                <li>{project.title}</li>
                            </ul>
                        </nav>
                    </div>
                    <div className="max-w-4xl mx-auto grid lg:max-w-5xl lg:gap-x-20">
                        <p className="text-sm leading-4 font-medium text-red-600 sm:text-red-600 dark:sm:text-red-600">
                            {project.type}
                        </p>
                        <h1 className="text-4xl font-bold text-white mt-4"><span>{project.title}</span></h1>
                        <dd className="flex items-center text-gray-50 mt-3">
                            <svg
                                width={24}
                                height={24}
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="mr-1 text-slate-400 dark:text-slate-500"
                                aria-hidden="true"
                            >
                                <path
                                    d="M18 11.034C18 14.897 12 19 12 19s-6-4.103-6-7.966C6 7.655 8.819 5 12 5s6 2.655 6 6.034Z"/>
                                <path d="M14 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"/>
                            </svg>
                            {project.location}
                        </dd>
                        <p className="my-4 text-sm leading-6 col-start-1 sm:col-span-2 lg:mt-6 lg:row-start-4 lg:col-span-1 text-slate-300">{project.description}</p>
                        <div className="grid grid-cols-1 gap-6">
                            {project.images.map((image, idx) => (
                                <img
                                    key={idx}
                                    src={image}
                                    alt={project.title}
                                    onClick={() => setModalConfig({
                                        isOpen: true,
                                        images: project.images.map((img, i) => ({
                                            src: img,
                                            alt: `${project.title} - view ${i + 1}`
                                        })),
                                        initialIndex: idx
                                    })}
                                    className="cursor-pointer rounded-lg transition-transform duration-200 hover:opacity-95"
                                    onError={(e) => e.target.src = homepageImg}
                                />
                            ))}
                        </div>

                    </div>
                </main>
            </div>
            {modalConfig.isOpen && (
                <ImageModal
                    images={modalConfig.images}
                    initialIndex={modalConfig.initialIndex}
                    onClose={() => setModalConfig({ isOpen: false, images: [], initialIndex: 0 })}
                />
            )}
        </div>
    );
};

export default ProjectDetail;